//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { DocumentModel } from '@app/catalog';
import { PresenterType } from '@app/shared';



@PresenterType({
  model: DocumentModel,
  key: 'tileTop'
})
@Component({
  selector: 'document-carousel-item',
  templateUrl: './document-carousel-item.component.html',
  styleUrl: './document-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentCarouselItemComponent {
  public data: WritableSignal<DocumentModel> = signal<DocumentModel>(undefined);
}
